module.exports = "/images/mp.svg?f79008213366a4d3776cb523ad5a7f42";